export default __webpack_public_path__ + "static/media/choiceLogo.d01822c3.png";